// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__309_G","text":"LimitedAccessBanner_text__xjZhX","button":"LimitedAccessBanner_button__18yL1"};